/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
    Card,
    Button,
    Row,
    Col,
    CardBody,
    // Form,
    CardFooter,
    FormGroup,
    Label,
    Input,
    Container,
    CardHeader,
    FormFeedback
} from "reactstrap";

import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import SimpleHeaderMobile from "components/Headers/SimpleHeaderMobile";
import SweetAlert from "react-bootstrap-sweetalert";
import ItemGambar1 from "components/SelectedFile/ItemGambar1";
import ItemGambar2 from "components/SelectedFile/ItemGambar2";
import ItemGambar3 from "components/SelectedFile/ItemGambar3";
import ItemGambar4 from "components/SelectedFile/ItemGambar4";
import ItemGambar5 from "components/SelectedFile/ItemGambar5";
import { getAddressMap } from "utils/getMapAddress";

// import Select2 from "react-select2-wrapper";

const CreateDocumentCanvaser = () => {
    const token = localStorage.token;
    const warehouseId = localStorage.warehouse;
    const username = localStorage.username;
    const trackingcode = localStorage.tc;
    const history = useHistory();
    const [namacustomer, setNamaCustomer] = useState("");
    const [description, setDescription] = useState("");
    const [image1, setImage1] = useState("");
    const [image2, setImage2] = useState("");
    const [image3, setImage3] = useState("");
    const [image4, setImage4] = useState("");
    const [image5, setImage5] = useState("");
    const [provinces, setProvinces] = useState([]);
    const [province, setProvince] = useState("");
    const [cities, setCities] = useState([]);
    const [city, setCity] = useState("");
    const [provinceError, setProvinceError] = useState(null);
    const [alamatotomatis, setAlamatOtomatis] = useState("");
    const [long, setLong] = useState(null);
    const [lat, setLat] = useState(null);
    const [alamat, setAlamat] = useState("");
    const [email, setEmail] = useState("");
    const [whatsapp, setWhatsapp] = useState("");
    const [namaproyek, setNamaProyek] = useState("")
    const [cityError, setCityError] = useState(null);
    const [alert, setAlert] = React.useState(null);
    const [loading, setLoading] = useState(false)
    const [isSpinner, setIsSpinner] = useState(false);

    useEffect(() => {
        updateLocation(); // langsung update awal

        const locationInterval = setInterval(() => {
            updateLocation();
        }, 20000); // update lokasi setiap 3 detik

        return () => {
            clearInterval(locationInterval);
        };
    }, []);

    const updateLocation = async () => {
        navigator.geolocation.getCurrentPosition(async (position) => {
            const lat = position.coords.latitude;
            const long = position.coords.longitude;
            setLat(lat);
            setLong(long);

            const pointAddress = await getAddressMap(lat, long);
            setAlamatOtomatis(pointAddress?.display_name || "Alamat tidak ditemukan");
        });
    };

    useEffect(() => {
        getProvince()
        // getCity()
    }, []);


    const getProvince = () => {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/province/list`, {
            headers
        })
            .then(data => {
                setProvinces(data.data.response_data)
            })
            .catch(function (error) {
                console.log(error)
            })
    }

    const getCity = (provinceId) => {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/city?province_id=${provinceId}`, {
            headers
        })
            .then(data => {
                setCities(data.data.response_data)
            })
            .catch(function (error) {
                console.log(error)
            })
    }

    const CreateItem = () => {
        setIsSpinner(true);
        setLoading(true)
        if (!namaproyek || !namacustomer || !province || !city || !alamat || !long || !lat || !whatsapp || !description) {
            return setGagalAlert("Harap isikan form yang kosong"),
                setIsSpinner(false),
                setLoading(false);
        }
        hideAlert();
        const headers = {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
        };

        const customerName = namacustomer.endsWith("(SC)")
            ? namacustomer
            : `${namacustomer} (SC)`;


        const myjson = JSON.stringify({
            warehouse_id: warehouseId,
            username_sc: username,
            tracking_code: trackingcode,
            manual_alamat_proyek: alamat,
            latitude_proyek: lat,
            longitude_proyek: long,
            keterangan_canvasing: description,
            alamat_proyek: alamatotomatis,
            pic: "",
            pic_phone: "",
            nama_proyek: namaproyek,
            customer: {
                name: customerName,
                address: alamatotomatis,
                province: province,
                city: city,
                latitude: lat,
                longitude: long,
                phone: whatsapp,
                fax: "",
                npwp: "",
                customer_email: email,
                price_type: 1,
                limit_piutang: 10000000,
                limit_hutang: 10000000,
                bank_name1: "",
                bank_account1: "",
                bank_number1: "",
                bank_name2: "",
                bank_account2: "",
                bank_number2: "",
            }
        });

        let data = new FormData();
        data.append("body", myjson)
        data.append("foto1", image1)
        data.append("foto2", image2)
        data.append("foto3", image3)
        data.append("foto4", image4)
        data.append("foto5", image5)
        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/canvasing-parent/save`, data, { headers })
            .then(function (response) {
                setIsSpinner(false);
                setSuccessAlert(response.data.message);
                setLoading(false)
                setTimeout(() => (history.push("/mobile/sales/page")), 1000);
            })
            .catch(function (error) {
                setIsSpinner(false);
                setGagalAlert(error.response.data.message);
                setLoading(false)
            });
    }

    const setSuccessAlert = (id) => {
        setAlert(
            <SweetAlert
                success
                showConfirm
                confirmBtnText="Ok"
                title={id}
                onCancel={hideAlert}
                onConfirm={hideAlert}
            />
        )
    }

    const setGagalAlert = (id) => {
        setAlert(
            <SweetAlert
                danger
                showConfirm
                confirmBtnText="Ok"
                title={id}
                onCancel={hideAlert}
                onConfirm={hideAlert}
            />
        );
    };

    const setQuestionAlert = () => {
        setAlert(
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Lanjutkan"
                confirmBtnBsStyle="danger"
                title="Apakah Kamu Yakin?"
                onConfirm={CreateItem}
                onCancel={hideAlert}
                focusCancelBtn
            />
        );
    };

    const hideAlert = () => {
        setAlert(null);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) {
            GetCekCode();
        }
    }

    return (
        <div>
            {alert}
            <div>
                {isSpinner ? (
                    <Container className="mt--10 pb-10 login-container">
                        <Row className="justify-content-center">
                            <Col lg="5" md="7">
                                <div className="d-flex flex-column align-items-center d-lg-none d-xl-none">
                                    <img
                                        src={require("assets/img/theme/loadingmobile1.gif").default}
                                        style={{
                                            textAlign: "center",
                                            height: "12rem",
                                            width: "12rem",
                                            paddingTop: "1rem",
                                        }}
                                        alt="loading"
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Container>
                ) : (
                    <>
                        <SimpleHeaderMobile to="/mobile/sales/page" judul="Tambah Dokumen" />
                        <Container className="mt--6" fluid>
                            <Row>
                                <div className="col">
                                    <Card className="bg-secondary shadow">
                                        <CardHeader>
                                            <h3>Tambah Dokumen</h3>
                                        </CardHeader>
                                        <CardBody>
                                            <Row md="12">
                                                <Col md="6">
                                                    <FormGroup row>
                                                        <Label
                                                            className="form-control-label"
                                                            for="exampleEmail"
                                                            sm={4}
                                                        >
                                                            Proyek
                                                            <span className="text-danger">*</span>
                                                        </Label>
                                                        <Col sm={7}>
                                                            <Input
                                                                autoComplete="off"
                                                                className="form-control-alternative"
                                                                type="text"

                                                                placeholder="Masukan Nama Proyek"
                                                                value={namaproyek}
                                                                onChange={(e) => {
                                                                    setNamaProyek(e.target.value);
                                                                }}
                                                            />
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup row>
                                                        <Label
                                                            className="form-control-label"
                                                            for="exampleEmail"
                                                            sm={4}
                                                        >
                                                            Nama Customer
                                                            <span className="text-danger">*</span>
                                                        </Label>
                                                        <Col sm={7}>
                                                            <Input
                                                                autoComplete="off"
                                                                className="form-control-alternative"
                                                                type="text"

                                                                placeholder="Masukan Nama Customer"
                                                                value={namacustomer}
                                                                onChange={(e) => {
                                                                    setNamaCustomer(e.target.value);
                                                                }}
                                                            />
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup row>
                                                        <Label
                                                            sm={4}
                                                            className="form-control-label"
                                                            htmlFor="exampleFormControlSelect3"
                                                        >
                                                            Province
                                                            <span className="text-danger">*</span>
                                                        </Label>
                                                        <Col sm={7}>
                                                            <Input
                                                                autoComplete="off"
                                                                name="Province"
                                                                type="select"
                                                                value={province}
                                                                invalid={provinceError === "invalid"}
                                                                onChange={(e) => {
                                                                    setProvince(e.target.value);
                                                                    if (e.target.value !== "") {
                                                                        setProvinceError("");
                                                                    }
                                                                    getCity(e.target.value);
                                                                }}
                                                            >
                                                                <option value="">Pilih Province</option>
                                                                {
                                                                    provinces.map((prov, key) => {
                                                                        return <option key={key} value={prov.id}>{prov.name}</option>
                                                                    })
                                                                }
                                                            </Input>
                                                            <FormFeedback>Province tidak boleh kosong</FormFeedback>
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup row>
                                                        <Label
                                                            sm={4}
                                                            className="form-control-label"
                                                            htmlFor="exampleFormControlSelect3"
                                                        >
                                                            Kota
                                                            <span className="text-danger">*</span>
                                                        </Label>
                                                        <Col sm={7}>
                                                            <Input
                                                                autoComplete="off"
                                                                name="Kota"
                                                                type="select"
                                                                value={city}
                                                                invalid={cityError === "invalid"}
                                                                onChange={(e) => {
                                                                    setCity(e.target.value);
                                                                    if (e.target.value !== "") {
                                                                        setCityError("");
                                                                    }
                                                                }}
                                                            >
                                                                <option value="">Pilih Kota</option>
                                                                {
                                                                    cities.map((city, key) => {
                                                                        return <option key={key} value={city.id}>{city.name}</option>
                                                                    })
                                                                }
                                                            </Input>
                                                            <FormFeedback>Kota tidak boleh kosong</FormFeedback>
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup row>
                                                        <Label
                                                            className="form-control-label"
                                                            for="exampleEmail"
                                                            sm={4}
                                                        >
                                                            Alamat
                                                            <span className="text-danger">*</span>
                                                        </Label>
                                                        <Col sm={7}>
                                                            <Input
                                                                autoComplete="off"
                                                                className="form-control-alternative"
                                                                type="text"

                                                                placeholder="Masukan Alamat"
                                                                value={alamat}
                                                                onChange={(e) => {
                                                                    setAlamat(e.target.value);
                                                                }}
                                                            />
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup row>
                                                        <Label
                                                            className="form-control-label"
                                                            for="exampleEmail"
                                                            sm={4}
                                                        >
                                                            Whatsapp
                                                            <span className="text-danger">*</span>
                                                        </Label>
                                                        <Col sm={7}>
                                                            <Input
                                                                autoComplete="off"
                                                                className="form-control-alternative"
                                                                type="text"

                                                                placeholder="Masukan No Whatsapp"
                                                                value={whatsapp}
                                                                onChange={(e) => {
                                                                    setWhatsapp(e.target.value);
                                                                }}
                                                            />
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup row>
                                                        <Label
                                                            className="form-control-label"
                                                            for="exampleEmail"
                                                            sm={4}
                                                        >
                                                            Email
                                                        </Label>
                                                        <Col sm={7}>
                                                            <Input
                                                                autoComplete="off"
                                                                className="form-control-alternative"
                                                                type="text"

                                                                placeholder="Masukan Email"
                                                                value={email}
                                                                onChange={(e) => {
                                                                    setEmail(e.target.value);
                                                                }}
                                                            />
                                                        </Col>
                                                    </FormGroup>
                                                    <FormGroup row>
                                                        <Label
                                                            className="form-control-label"
                                                            for="exampleEmail"
                                                            sm={4}
                                                        >
                                                            Keterangan
                                                            <span className="text-danger">*</span>
                                                        </Label>
                                                        <Col sm={7}>
                                                            <Input
                                                                autoComplete="off"
                                                                className="form-control-alternative"
                                                                type="textarea"
                                                                name="descripsi"
                                                                rows="8"
                                                                placeholder="Masukan Keterangan"
                                                                value={description}
                                                                onChange={(e) => {
                                                                    setDescription(e.target.value);
                                                                }}
                                                            />
                                                        </Col>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>

                                    <Card className="bg-secondary shadow">
                                        <CardHeader>
                                            <h3>Upload Gambar</h3>
                                        </CardHeader>
                                        <CardBody>
                                            <Row>
                                                <Col md="12">
                                                    <FormGroup>
                                                        <Row className="mt-3">
                                                            {[1, 2, 3, 4, 5].map((num, index) => (
                                                                <Col key={index} xs="6" sm="4" md="2" className="mb-3 text-center">
                                                                    <label htmlFor={`formId${num}`} style={{ cursor: 'pointer' }}>
                                                                        <input
                                                                            hidden
                                                                            id={`formId${num}`}
                                                                            name="file"
                                                                            type="file"
                                                                            accept="image/*"
                                                                            onChange={(event) => {
                                                                                const file = event.target.files[0];
                                                                                if (file) {
                                                                                    switch (num) {
                                                                                        case 1: setImage1(file); break;
                                                                                        case 2: setImage2(file); break;
                                                                                        case 3: setImage3(file); break;
                                                                                        case 4: setImage4(file); break;
                                                                                        case 5: setImage5(file); break;
                                                                                        default: break;
                                                                                    }
                                                                                }
                                                                            }}
                                                                        />
                                                                        {num === 1 && (
                                                                            <ItemGambar1
                                                                                onclick={() => { }}
                                                                                imageSrc1={image1 ? URL.createObjectURL(image1) : null}
                                                                            />
                                                                        )}
                                                                        {num === 2 && (
                                                                            <ItemGambar2
                                                                                onclick={() => { }}
                                                                                imageSrc2={image2 ? URL.createObjectURL(image2) : null}
                                                                            />
                                                                        )}
                                                                        {num === 3 && (
                                                                            <ItemGambar3
                                                                                onclick={() => { }}
                                                                                imageSrc3={image3 ? URL.createObjectURL(image3) : null}
                                                                            />
                                                                        )}
                                                                        {num === 4 && (
                                                                            <ItemGambar4
                                                                                onclick={() => { }}
                                                                                imageSrc4={image4 ? URL.createObjectURL(image4) : null}
                                                                            />
                                                                        )}
                                                                        {num === 5 && (
                                                                            <ItemGambar5
                                                                                onclick={() => { }}
                                                                                imageSrc5={image5 ? URL.createObjectURL(image5) : null}
                                                                            />
                                                                        )}
                                                                    </label>
                                                                </Col>
                                                            ))}
                                                        </Row>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                        <CardFooter disabled={loading} className="d-flex justify-content-between">
                                            <Link className="btn btn-info" to="/mobile/sales/page">
                                                Kembali
                                            </Link>
                                            <Button disabled={loading} color="danger" onClick={() => setQuestionAlert()}>
                                                Simpan
                                            </Button>
                                        </CardFooter>
                                    </Card>
                                </div>
                            </Row>
                        </Container>
                    </>
                )};
            </div>
        </div>

    );
};

export default CreateDocumentCanvaser;